import axios from 'axios'

// TODO: Fill in the correct API URLs

const API_URL_SendCode = 'api/worker/sendVerificationCode'
const API_URL_VerifyCode = 'api/worker/resetPassword/verify'
const API_URL_UPDATEPASSWORD = 'api/worker/resetWorkerPassword'

// Send code to Worker Phone number
const sendCodeService = async (phone) => {
    try {
        // Ensure the phone number is sent in the request body as { workerPhone }
        const response = await axios.post(API_URL_SendCode, { workerPhone: phone }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            console.log(error.response.data.message);
        }
        if (error.response && error.response.status === 400) {
            return { message: "Something Went wrong" };
        }
        if (error.response || error.response.status === 401) {
            throw new Error("User does not exist :(");
        }
        throw error;
    }
}

const verifyCodeService = async (data) => {
    try {
        // Send workerPhone and code directly in the request body
        const response = await axios.post(API_URL_VerifyCode, {
            workerPhone: data.workerPhone,
            code: data.code
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            console.log(error.response.data.message);
        }
        if (error.response && error.response.status === 400) {
            return { message: "Something Went wrong" };
        }
        if (error.response && error.response.status === 401) {
            throw new Error("Invalid verification Code :(");
        }
        if (error.response && error.response.status === 500) {
            throw new Error("Old Code Submission or Code alreadyverified");
        }
        throw error;
    }
}

// Don't forget to include backend checks for password length
const submitNewPassword = async (newPassword, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json', // Ensure JSON body is parsed correctly
        },
    }
    try {
        const response = await axios.post(API_URL_UPDATEPASSWORD, { newPassword }, config)
        return response.data
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            console.log(error.response.data.message);
        }
        throw error;
    }
}

const passwordResetServiceWorker = {
    sendCodeService,
    verifyCodeService,
    submitNewPassword,
}

export default passwordResetServiceWorker;
